import Footer from "../pages/Footer/Footer";
import Nav from "./Nav";

const withNavElements = (WrappedComponent) => {
  const WithNavElements = (props) => {
    const { navElements, ...rest } = props;
    const navElementProps = {
      navElements,
    };
    return (
      <>
        <Nav />
        <WrappedComponent {...rest} {...navElementProps} />
        <Footer />
      </>
    );
  };
  return WithNavElements;
};

export default withNavElements;
